import { Document } from '../../../modules/design-system';
import { SleekButton } from '../../../modules/theme';

type Props = {
  onClick: () => void;
  /** Locked while the pack is sold out — the pill stays so the page doesn't shift. */
  disabled?: boolean;
  className?: string;
};

/** The lobby's "What's inside" pill under the pack title — opens the page. */
export function WhatsInsideButton({ onClick, disabled = false, className = '' }: Props) {
  return (
    <SleekButton name="WhatsInsideButton" onClick={onClick} disabled={disabled} className={className}>
      <Document size={16} />
      {"What's inside"}
    </SleekButton>
  );
}
